import React, { useEffect, useState, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Loader2, CheckCircle2, XCircle } from 'lucide-react';
import AuthShell from '../components/auth/AuthShell';
import { useAuth } from '../context/AuthContext';

const VerifyEmail = () => {
  const { verifyEmail } = useAuth();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [status, setStatus] = useState('loading'); // loading | success | error
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) { setStatus('error'); return; }
    verifyEmail(token)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [token, verifyEmail]);

  return (
    <AuthShell
      title="Email Verification"
      footer={<Link to="/login" className="text-mahogany font-medium hover:underline">Continue to sign in</Link>}
    >
      <div className="p-8 rounded-2xl bg-rose-soft/50 border border-rose/60 text-center">
        {status === 'loading' && (
          <>
            <Loader2 className="w-10 h-10 animate-spin text-mahogany mx-auto" />
            <p className="mt-4 text-mahogany/80">Verifying your email…</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle2 className="w-12 h-12 text-green-600 mx-auto" />
            <p className="mt-4 font-serif-display text-2xl text-burgundy">Email verified!</p>
            <p className="mt-1 text-mahogany/80 text-sm">Thank you. Your account is now fully activated.</p>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-12 h-12 text-mahogany mx-auto" />
            <p className="mt-4 font-serif-display text-2xl text-burgundy">Link invalid or expired</p>
            <p className="mt-1 text-mahogany/80 text-sm">Please sign in and request a new verification email.</p>
          </>
        )}
      </div>
    </AuthShell>
  );
};

export default VerifyEmail;
